<template>
  <div>
    <b-row>
      <b-col :cols="valueRow">
        <b-form-group label="Telefone">
          <b-input-group class="mb-50">
            <masked-input
              ref="telefone"
              v-model="value.telefone"
              :mask="['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
              class="form-control"
              :disabled="disabled"
            />
            <b-input-group-append>
              <b-button
                v-b-tooltip.hover
                :pressed.sync="value.telefoneWhatsApp"
                title="Telefone possui WhatsApp"
                :size="isCadastroModal ? 'sm' : ''"
                :style="isCadastroModal ? 'padding: 0.8em 1.2rem' : ''"
                :variant="value.telefoneWhatsApp ? 'success' : 'outline-success'"
                class="whatsapp-btn"
                :disabled="disabled"
              >
                <feather-icon icon="MessageCircleIcon" />
              </b-button>
            </b-input-group-append>
          </b-input-group>

          <b-form-checkbox
            v-if="exibeChecksEnviaContrato"
            v-model="value.enviaContratoTelefone"
            :value="true"
            :unchecked-value="false"
            :disabled="desabilitarCheckEnviaContratoTelefone()"
            @change="verificarUnicoCheckTelefone"
          >
            Enviar contrato (Whatsapp)
          </b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col
        v-if="mostrarRamal"
        cols="2"
      >
        <b-form-group
          label="Ramal"
        >
          <b-form-input
            v-model="value.ramal"
          />
        </b-form-group>
      </b-col>
      <b-col :cols="6">
        <b-form-group label="Celular">
          <b-input-group class="mb-50">
            <masked-input
              ref="celular"
              v-model="value.celular"
              :mask="['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
              class="form-control"
              placeholder=""
              :disabled="disabled"
            />
            <b-input-group-append>
              <b-button
                v-b-tooltip.hover
                :pressed.sync="value.celularWhatsApp"
                title="Celular possui WhatsApp"
                :size="isCadastroModal ? 'sm' : ''"
                :style="isCadastroModal ? 'padding: 0.8em 1.2rem' : ''"
                :variant="value.celularWhatsApp ? 'success' : 'outline-success'"
                class="whatsapp-btn"
                :disabled="disabled"
              >
                <feather-icon icon="MessageCircleIcon" />
              </b-button>
            </b-input-group-append>
          </b-input-group>

          <b-form-checkbox
            v-if="exibeChecksEnviaContrato"
            v-model="value.enviaContratoCelular"
            :value="true"
            :unchecked-value="false"
            :disabled="desabilitarCheckEnviaContratoCelular()"
            @change="verificarUnicoCheckCelular"
          >
            Enviar contrato (Whatsapp)
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<style>
.custom-control-label {
  font-size: small !important;
}

</style>

<script>
import { mapGetters } from 'vuex'

export default {
  nome: 'TelefoneCelular',
  props: {
    value: {
      type: Object,
      default: () => { },
    },
    isCadastroModal: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    ocultarDoContrato: {
      type: Boolean,
      default: false,
    },
    exibeChecksEnviaContrato: {
      type: Boolean,
      default: false,
    },
    mostrarRamal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valueRow: 6,
    }
  },
  created() {
    if (this.mostrarRamal) {
      this.valueRow = 4
    }
  },
  computed: {
    ...mapGetters('proposta', ['getStatusProposta']),
  },
  watch: {
    // eslint-disable-next-line
    'value.celularWhatsApp'(newValue) {
      if (newValue === false) {
        this.$set(this.value, 'enviaContratoCelular', false)
      }
    },
    // eslint-disable-next-line
    'value.telefoneWhatsApp'(newValue) {
      if (newValue === false) {
        this.$set(this.value, 'enviaContratoTelefone', false)
      }
    },
    // eslint-disable-next-line
    'value.telefone'(newValue) {
      if (this.removeMascaraTelefone(newValue).length < 10) {
        this.$set(this.value, 'enviaContratoTelefone', false)
      }
    },
    // eslint-disable-next-line
    'value.celular'(newValue) {
      if (this.removeMascaraTelefone(newValue).length < 11) {
        this.$set(this.value, 'enviaContratoCelular', false)
      }
    },
  },
  methods: {
    removeMascaraTelefone(value) {
      return value.replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', '')
        .replaceAll('_', '')
    },
    desabilitarCheckEnviaContratoTelefone() {
      return this.ocultarDoContrato
      || !this.value.telefone
      || this.removeMascaraTelefone(this.value.telefone).length < 10
      || !this.value.telefoneWhatsApp
    },
    desabilitarCheckEnviaContratoCelular() {
      return this.ocultarDoContrato
      || !this.value.celular
      || this.removeMascaraTelefone(this.value.celular).length < 11
      || !this.value.celularWhatsApp
    },
    verificarUnicoCheckTelefone(checked) {
      if (checked) {
        this.$set(this.value, 'enviaContratoCelular', !checked)
      }

      if (this.getStatusProposta === 9) {
        this.$emit('altera-checks-envia-comtrato')
      }
    },
    verificarUnicoCheckCelular(checked) {
      if (checked) {
        this.$set(this.value, 'enviaContratoTelefone', !checked)
      }

      if (this.getStatusProposta === 9) {
        this.$emit('altera-checks-envia-comtrato')
      }
    },
  },
}
</script>
